import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';

// Block macOS swipe-back/forward navigation gestures
// This catches both trackpad swipes and mouse horizontal scroll
document.addEventListener('wheel', (e) => {
  // Only block horizontal scroll that could trigger navigation
  if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 5) {
    const target = e.target as HTMLElement;
    const scrollable = target.closest('[style*="overflow"]') || target.closest('.scrollable');
    if (!scrollable) {
      e.preventDefault();
    }
  }
}, { passive: false });

// Also block popstate (browser back) if triggered by gesture during editing
window.addEventListener('popstate', () => {
  // Re-push the current state to prevent accidental navigation
  // Only if user was likely interacting with a form
  const active = document.activeElement;
  if (active && (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA' || active.tagName === 'SELECT')) {
    window.history.pushState(null, '', window.location.href);
  }
});
// Push initial state so popstate handler works
window.history.pushState(null, '', window.location.href);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
